import React, { useEffect } from "react";

const FeaturesIconsSlider = ({ categories }) => {
  useEffect(() => {
    // Wait for DOM to be ready and Swiper to be available
    const initializeSlider = () => {
      if (!window.Swiper) {
        console.log("Swiper not available yet, retrying...");
        setTimeout(initializeSlider, 100);
        return;
      }

      // Initialize Icon Box slider (mobile only)
      const iconBoxElement = document.querySelector(".tf-sw-mobile");
      if (iconBoxElement) {
        console.log("Checking Icon Box slider...");
        const preview = parseInt(iconBoxElement.dataset.preview) || 1;
        const spacing = parseInt(iconBoxElement.dataset.space) || 15;

        // Only initialize Swiper on mobile devices (max-width: 767px)
        if (window.innerWidth <= 767) {
          if (!iconBoxElement.swiper) {
            new window.Swiper(".tf-sw-mobile", {
              slidesPerView: preview,
              spaceBetween: spacing,
              speed: 1000,
              pagination: {
                el: ".sw-pagination-mb",
                clickable: true,
              },
              slidesPerGroup: 1,
              allowTouchMove: true,
              touchRatio: 1,
              touchAngle: 45,
              grabCursor: true,
            });
            console.log("Icon Box slider initialized successfully (mobile)");
          }
        } else {
          // On desktop, destroy Swiper if it exists and remove styles
          if (iconBoxElement.swiper) {
            iconBoxElement.swiper.destroy(true, true);
          }
          const swiperWrapper = document.querySelector(
            ".tf-sw-mobile .swiper-wrapper"
          );
          const swiperSlides = document.querySelectorAll(
            ".tf-sw-mobile .swiper-slide"
          );
          if (swiperWrapper) swiperWrapper.removeAttribute("style");
          swiperSlides.forEach((slide) => slide.removeAttribute("style"));
          console.log("Icon Box items displayed in row (desktop)");
        }
      }
    };

    // Initial attempt
    initializeSlider();

    // Retry after a delay to ensure DOM is fully loaded
    const timer = setTimeout(initializeSlider, 1000);

    // Additional retry for mobile sliders
    const mobileTimer = setTimeout(initializeSlider, 2000);

    // Add resize listener for Icon Box slider
    const handleResize = () => {
      const iconBoxSlider = document.querySelector(".tf-sw-mobile");
      if (iconBoxSlider) {
        if (window.innerWidth > 767) {
          // Destroy Swiper on desktop
          if (iconBoxSlider.swiper) {
            iconBoxSlider.swiper.destroy(true, true);
          }
          const swiperWrapper = document.querySelector(
            ".tf-sw-mobile .swiper-wrapper"
          );
          const swiperSlides = document.querySelectorAll(
            ".tf-sw-mobile .swiper-slide"
          );
          if (swiperWrapper) swiperWrapper.removeAttribute("style");
          swiperSlides.forEach((slide) => slide.removeAttribute("style"));
          console.log("Icon Box: Swiper destroyed for desktop");
        } else if (window.innerWidth <= 767) {
          // Initialize Swiper on mobile if not already initialized
          if (!iconBoxSlider.swiper) {
            const preview = parseInt(iconBoxSlider.dataset.preview) || 1;
            const spacing = parseInt(iconBoxSlider.dataset.space) || 15;

            new window.Swiper(".tf-sw-mobile", {
              slidesPerView: preview,
              spaceBetween: spacing,
              speed: 1000,
              pagination: {
                el: ".sw-pagination-mb",
                clickable: true,
              },
              slidesPerGroup: 1,
              allowTouchMove: true,
              touchRatio: 1,
              touchAngle: 45,
              grabCursor: true,
            });
            console.log("Icon Box: Swiper initialized for mobile");
          }
        }
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timer);
      clearTimeout(mobileTimer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section
      className="flat-spacing-7 flat-iconbox wow fadeInUp"
      data-wow-delay="0s"
    >
      <div className="container">
        <div className="wrap-carousel wrap-mobile ">
          <div
            dir="ltr"
            className="swiper tf-sw-mobile"
            data-preview="1"
            data-space="15"
          >
            <div className="swiper-wrapper wrap-iconbox">
              {categories.map((category, index) => (
                <div key={index} className="swiper-slide">
                  <div className="tf-icon-box style-border-line text-center">
                    <div className="icon">
                      <i className={category.icon}></i>
                    </div>
                    <div className="content">
                      <div className="title">{category.title}</div>
                      <p>{category.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="sw-dots style-2 sw-pagination-mb justify-content-center"></div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesIconsSlider;
